import { render, staticRenderFns } from "./announcementList.vue?vue&type=template&id=4776af3c&scoped=true&"
import script from "./announcementList.vue?vue&type=script&lang=js&"
export * from "./announcementList.vue?vue&type=script&lang=js&"
import style0 from "./announcementList.vue?vue&type=style&index=0&id=4776af3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4776af3c",
  null
  
)

export default component.exports